import React from "react";
import { getLanguageCountryCode } from "../../../utils/appLanguages";

/**
 * Renders a Semantic UI country flag (sprite-based, works on Windows).
 */
const LanguageFlag = ({ code, className = "" }) => {
  const country = getLanguageCountryCode(code);
  return (
    <i
      className={`${country} flag language-flag-icon${className ? ` ${className}` : ""}`}
      aria-hidden
    />
  );
};

export default LanguageFlag;
